<template>
  <q-select
    v-model="selectedUnitId"
    :options="unitsOptions"
    :stack-label="label"
    placeholder="Unit"
    clearable
    @clear="clear"
    @input="unitSelected"
  />
</template>

<script>

export default {
  name: 'SelectPropertyUnit',
  props: {
    propertyId: {
      required: false,
      type: Number,
      default: null,
    },
    units: {
      type: Array,
      default: null,
    },
    currentUnitId: {
      type: Number,
    },
    label: {
      type: String,
      default: 'Unit',
    },
  },
  data() {
    return {
      selectedUnitId: this.currentUnitId || null,
      unitsOptions: [],
    };
  },
  watch: {
    propertyId: {
      immediate: true,
      handler() {
        this.getUnitsOptions();
      },
    },
  },
  methods: {
    async getUnitsOptions() {
      let units = this.units;
      if (!units) {
        units = await this.api().request('GET', `properties/${this.propertyId}/units`);
      }
      this.unitsOptions = units.map(({ id, name }) => ({ label: name, value: id }));
    },
    unitSelected() {
      this.emitSelectedUnit();
    },
    clear() {
      this.selectedUnitId = null;
      this.emitSelectedUnit();
    },
    emitSelectedUnit() {
      this.$emit('change', this.selectedUnitId);
    },
  },
};
</script>
